import { Component, Self, Optional, Input } from '@angular/core';
import {  NgControl, ControlValueAccessor } from '@angular/forms';
import { InputBaseComponent } from '../inputbase/inputbase.component';

@Component({
  selector: 'lebara-date',
  templateUrl: './dateinput.component.html',
  styleUrls: ['../inputbase/inputbase.component.scss', './dateinput.component.scss']
})
export class DateinputComponent extends InputBaseComponent implements ControlValueAccessor {
  public val: Date;
  public selectedDay: number;
  public selectedMonth: number;
  public selectedYear: number;
  public days: Array<number> = [];
  public months: Array<number> = [];
  public years: Array<number> = [];

  @Input('explanation') public explanation: string;

  constructor(@Self() @Optional() me: NgControl) {

    super(me);

    if (this.me) {
      this.me.valueAccessor = this;
    }
    this.initArrays();
  }

  private initArrays(): void {
    this.days = [];
    for (let d = 1; d <= 31; d++) {
      this.days.push(d);
    }
    this.months = [];
    for (let m = 1; m <= 12; m++) {
      this.months.push(m);
    }

    const thisYear = new Date().getFullYear();
    this.years = [];
    for (let y = 0; y < 2; y++) {
      this.years.push(thisYear + y);
    }
  }

  public get isEmpty(): boolean {
    return !this.val;
  }

  public onDayChange(event: Event): void {
    const day = (event.target as any).value;
    this.val.setDate(day);
    this.value = this.val;
  }
  public onMonthChange(event: Event): void {
    const month = this.selectedMonth;
    this.val.setMonth(month - 1);
    this.value = this.val;
  }
  public onYearChange(event: Event): void {
    const year = (event.target as any).value;
    this.val.setFullYear(year);
    this.value = this.val;
  }

  public writeValue(value: any): void {
    this.val = value;
    if (this.val instanceof Date) {
      this.selectedDay = this.val.getDate();
      this.selectedMonth = this.val.getMonth() + 1;
      this.selectedYear = this.val.getFullYear();
    }

  }

  public set value(val: Date) {
    // this value is updated by programmatic changes if( val !== undefined && this.val !== val){
    this.val = val;
    if (val instanceof Date) {
      this.selectedDay = val.getDate();
      this.selectedMonth = val.getMonth() + 1;
      this.selectedYear = val.getFullYear();
    }

    this.onChange(val);
    this.onTouch(val);
  }
}
